module.exports = __webpack_public_path__ + "img/circle.3e2cc9fa.svg";